import React, { FC } from 'react';
import './FontIcon.scss';

type IProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLElement>,
  HTMLElement
>;
type SpanProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLSpanElement>,
  HTMLSpanElement
>;

interface FontIconProps extends SpanProps {
  label?: IProps['aria-label'];
  iconName: IProps['className'];
  iconSize?: 'small' | 'medium' | 'large' | 'xLarge';
  iconPosition?: 'left' | 'right';
  iconProps?: Omit<IProps, 'children'>;
  contentProps?: Omit<SpanProps, 'children'>;
}

export const FontIcon: FC<FontIconProps> = ({
  label,
  iconName,
  iconSize = 'small',
  iconPosition = 'left',
  children,
  iconProps,
  contentProps,
  ...props
}) => {
  const containerClassName = props?.className || '';
  const iconClassName = iconProps?.className || '';
  const contentClassName = contentProps?.className || '';
  const emptyContentClassName =
  children === undefined || children === null ? 'empty' : '';
  return (
    <span
      {...props}
      className={`font-icon-container icon-${iconPosition} ${containerClassName}`}>
      <i
        aria-label={label}
        {...iconProps}
        className={`font-icon fa ${emptyContentClassName} ${iconName} ${iconSize} ${iconClassName}`}
      />
      <span
        {...contentProps}
        className={`font-icon-content ${contentClassName}`}>
        {children}
      </span>
    </span>
  );
};

export default FontIcon;
